
import render from './render';


export {
    render
}